module.exports = __webpack_public_path__ + "media/images/phonerepair-f1611ddc59b64c620fef55c9ecd2ba04.png";